import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AppThunk } from '../../shared/store'
import { getAllowedChatTypesAPI } from '../../shared/api/chat_api'
import { ChatTypeEnum, IChatOption } from '../../shared/models/chat_models'
// import { getMapDatasetsAPI } from '../../shared/api/map_api'
// import { setDataSets } from '../map/map-slice'
import { ChatOptionEnum } from './chat-models'

export interface IChatState {
  loading: boolean,
  selectedChatType: string | null,
  allowedChatTypes: Array<string> | null,
  chatOptions: Array<IChatOption> | null,
  allowedDatasets: Array<string> | null,
  selectedDataset: string | null,
}

const initialState: IChatState = {
    loading: false,
    selectedChatType: null,
    allowedChatTypes: null,
    chatOptions: null,
    allowedDatasets: null,
    selectedDataset: null,
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setSelectedChatType:  (state, action: PayloadAction<string>) => {
        state.selectedChatType = action.payload
    },
    setAllowedChatTypes: (state, action: PayloadAction<Array<string>>) => {
        state.allowedChatTypes = action.payload
    },
    setChatOptions: (state, action: PayloadAction<Array<IChatOption>>) => {
        state.chatOptions = action.payload
    },
    allowedDatasets: (state, action: PayloadAction<Array<string>>) => {
        state.allowedDatasets = action.payload
    },
    setSelectedDataset: (state, action: PayloadAction<string>) => {
        state.selectedDataset = action.payload
    }
  }
})

export const fetchAllowedChatTypes = (): AppThunk => async (dispatch) => {
  dispatch(setLoading(true))

  try {
    const allowedChatTypes = (await getAllowedChatTypesAPI()).data
    dispatch(setAllowedChatTypes(allowedChatTypes))

    const chatOptions: Array<IChatOption> = []

    allowedChatTypes.forEach((type) => {
        if(type === ChatTypeEnum.QUERY)
            chatOptions.push({name: "debug", label: 'Debug', checked: false, type: 'button'})

        if(type === ChatTypeEnum.QNA && allowedChatTypes.length > 1){
            chatOptions.push({
                name: ChatOptionEnum.CHAT_TYPE,
                label: "Chat Type",
                type: 'radio',
                checked: false,
                radioOptions: [
                    {label: "Conversation", value: ChatTypeEnum.QNA},
                    {label: "Data Query", value: ChatTypeEnum.QUERY}
                ]
            })
        }
    })

    dispatch(setChatOptions(chatOptions))

    if (allowedChatTypes)
        dispatch(setSelectedChatType(allowedChatTypes[0]))

  }
  catch(e) {
    dispatch(setAllowedChatTypes([]))
  } finally {
    dispatch(setLoading(false))
  }
};

// NOTE: This is reusing the allowed datasets from the map API, we can split this out later
export const fetchAllowedChatDatasets = (): AppThunk => async (dispatch) => {
//     dispatch(setLoading(true))
    
//     try {
//         const dataSets = (await getMapDatasetsAPI()).data
//         dispatch(setDataSets(dataSets))

//         if(dataSets.length === 1)
//             dispatch(setSelectedDataset(dataSets[0]))
//     } catch(e) {
//         console.error("Exception in getting datasets: ", e)
//         dispatch(setDataSets([]))
//     } finally {
//         dispatch(setLoading(true))
//     }
}


export const { 
    setLoading, 
    setSelectedChatType, 
    setAllowedChatTypes, 
    setChatOptions,
    allowedDatasets,
    setSelectedDataset,
} = chatSlice.actions

export const sliceActions = chatSlice.actions

export default chatSlice.reducer